import { render, staticRenderFns } from "./StockSlipSkeleton.vue?vue&type=template&id=61bf1e18"
import script from "./StockSlipSkeleton.vue?vue&type=script&lang=js"
export * from "./StockSlipSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports